import initSocket from 'config/socket-io';
import useAuthSelector from 'modules/shared/hooks/useAuthSelector';
import { useEffect, useRef } from 'react';
import { Socket } from 'socket.io-client';
import { ProgressGPTSocketMessage } from '../helpers/progressgpt.types';

interface UseProgressGPTSocketListenerParams {
    onMessage: (data: ProgressGPTSocketMessage) => void;
}

export function useProgressGPTSocketListener(params: UseProgressGPTSocketListenerParams) {
    const { token, user: authUser } = useAuthSelector();

    const { onMessage } = params;

    const socketRef = useRef<Socket | null>(null);

    useEffect(() => {
        socketRef.current = initSocket();

        socketRef.current.auth = {
            token,
        };

        socketRef.current.on('connect', () => {
            socketRef.current.emit('progressgpt:joinroom');

            socketRef.current.on(`progressgpt:message`, (data: ProgressGPTSocketMessage) => {
                onMessage(data);
            });
        });

        return () => {
            socketRef.current.off();
            socketRef.current.disconnect();
        };
    }, [authUser._id, onMessage, token]);
}

export default useProgressGPTSocketListener;
